import { Helmet } from 'react-helmet-async';
import { AdsWithProvider } from 'src/components/visibility';

export default function VisibilityAds() {
  return (
    <>
      <Helmet>
        <title>Ads</title>
      </Helmet>

      <AdsWithProvider />
    </>
  );
}
